import axios from "axios";

import { ApiService } from "../../../../servicios/api.service";

export class BeneficioApi {
  static endPoint = "visita/beneficio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static async countByComercioId(comercioId) {
    const response = await axios.get(
      this.BasePath + "comercio/" + comercioId + "/count"
    );

    return response.data;
  }

  static async getListByComercioIdWithPagination(comercioId, pagination) {
    const response = await axios.post(
      this.BasePath + "comercio/" + comercioId,
      pagination
    );

    return response.data;
  }
}
